import { useMutation } from "react-query";
import * as shift from "services/configuration/shift/shift";

export const useShiftList = () => {
  return useMutation((formData) => shift.shiftList(formData));
};

export const useGetShift = () => {
  return useMutation((id) => shift.getShift(id));
};

export const useAddShift = () => {
  return useMutation((formData) => shift.addShift(formData));
};

export const useEditShift = () => {
  return useMutation((formData) => shift.editShift(formData));
};

export const useDeleteShift = () => {
  return useMutation((id) => shift.deleteShift(id));
};

export const useShiftStatus = () => {
  return useMutation((id) => shift.changeShiftStatus(id));
};
